import { render, staticRenderFns } from "./differentRules.vue?vue&type=template&id=2ac74320&scoped=true"
import script from "./differentRules.vue?vue&type=script&lang=js"
export * from "./differentRules.vue?vue&type=script&lang=js"
import style0 from "./differentRules.vue?vue&type=style&index=0&id=2ac74320&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac74320",
  null
  
)

export default component.exports